import { SVGProps } from "react";

export function RoundTransferHorizontalLinear(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="20px"
      height="20px"
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="12" cy="12" r="10"></circle>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M17 10H7l3.438-3M7 14h10l-3.437 3"
        ></path>
      </g>
    </svg>
  );
}
